import { Products } from '../../services/api/products'
import { Inventory } from '../../services/api/inventory'
import { InventoryProductItems } from '../../services/api/firebase'
import {
	ADD_PRODUCT_SUCCESS,
	FETCH_INVENTORY_SUCCESS,
	FETCH_PRODUCTS_SUCCESS,
	FETCH_PRODUCT_CATEGORIES_SUCCESS,
	FETCH_PRODUCT_DETAILS_SUCCESS,
	FETCH_PRODUCT_METRICS_SUCCESS,
	FETCH_WAREHOUSE_DETAILS_SUCCESS,
	UPDATE_PRODUCT_SUCCESS,
	FETCH_INVENTORY_PRODUCTS_SUCCESS,
	FETCH_INVENTORY_SKUS_SUCCESS,
	UPDATE_INVENTORY_PRODUCT_ITEM_SUCCESS,
	ADD_INVENTORY_PRODUCT_ITEM_SUCCESS,
	FETCH_INVENTORY_FEED_ITEMS_SUCCESS,
	ADD_INVENTORY_FEED_ITEM,
	FETCH_INVENTORY_ON_HAND_STOCK_SUCCESS,
	FETCH_INVENTORY_STOCK_MONITORING_SUCCESS,
	FETCH_MORE_INVENTORY_FEED_ITEMS_SUCCESS,
	FETCH_INVENTORY_ORDER_MOVEMENT_SUCCESS,
	FETCH_BLOCKED_INVENTORY_SUCCESS,
	BLOCK_INVENTORY_ITEMS_SUCCESS,
	SORT_INVENTORY_SKUS,
	FETCH_INVENTORY_SCAN_ADHERENCE_SUCCESS
} from './action-types'

export function fetchProducts ({
	searchTerm,
	page = 0,
	category,
	subCategory1,
	subCategory2,
	subCategory3,
	subCategory4,
	subCategory5
} = {}) {
	return async (dispatch) => {
		const response = await Products.index({
			searchTerm,
			page,
			category,
			subCategory1,
			subCategory2,
			subCategory3,
			subCategory4,
			subCategory5
		})
		dispatch({ type: FETCH_PRODUCTS_SUCCESS, payload: response.data })
	}
}

export function addProduct (params) {
	return async (dispatch) => {
		const response = await Products.create(params)
		dispatch({ type: ADD_PRODUCT_SUCCESS, payload: response.data })
	}
}

export function updateProduct (id, params) {
	return async (dispatch) => {
		const response = await Products.update(id, params)
		dispatch({ type: UPDATE_PRODUCT_SUCCESS, payload: response.data })
	}
}

export function fetchProductCategories (industry) {
	return async (dispatch) => {
		const response = await Products.fetchCategories(industry)
		dispatch({ type: FETCH_PRODUCT_CATEGORIES_SUCCESS, payload: { data: response.data, industry } })
	}
}

export function fetchProductDetails (id) {
	return async (dispatch) => {
		const response = await Products.single(id, {
			inventory: true,
			packages: true
		})
		dispatch({ type: FETCH_PRODUCT_DETAILS_SUCCESS, payload: { data: response.data, id } })
	}
}

export function fetchInventory ({
	page = 0,
	searchTerm,
	locationId,
	updatedFrom,
	updatedTo,
	minQuantity,
	maxQuantity
} = {}) {
	return async (dispatch) => {
		const response = await Inventory.indexInventory({
			page,
			searchTerm,
			locationId,
			updatedFrom,
			updatedTo,
			minQuantity,
			maxQuantity
		})
		dispatch({ type: FETCH_INVENTORY_SUCCESS, payload: response.data })
	}
}

export function fetchInventoryProducts ({
	page = 0,
	searchTerm,
	locationId,
	updatedFrom,
	updatedTo,
	isInStock,
	isOrdered,
	skus,
	createdFrom,
	createdTo,
	blocked
} = {}) {
	return async (dispatch) => {
		const response = await Inventory.indexInventoryProducts({
			page,
			searchTerm,
			locationId,
			updatedFrom,
			updatedTo,
			isInStock,
			isOrdered,
			skus,
			createdFrom,
			createdTo,
			blocked
		})
		dispatch({ type: FETCH_INVENTORY_PRODUCTS_SUCCESS, payload: { data: response.data, isInStock } })
	}
}

export function fetchInventoryOnHandStock (
	{
		page = 0,
		searchTerm,
		updatedFrom,
		updatedTo,
		skus,
		createdFrom,
		createdTo,
		shifts,
		packCodes,
		machineCodes,
		shelfLives,
		facilities,
		sortInTransitQuantity,
		sortOnHandStockQuantity
	} = {}
) {
	return async (dispatch) => {
		const response = await Inventory.indexInventoryOnHandStock({
			page,
			searchTerm,
			updatedFrom,
			updatedTo,
			skus,
			createdFrom,
			createdTo,
			shifts,
			packCodes,
			machineCodes,
			shelfLives,
			facilities,
			sortInTransitQuantity,
			sortOnHandStockQuantity
		})
		dispatch({ type: FETCH_INVENTORY_ON_HAND_STOCK_SUCCESS, payload: response.data })
	}
}

export function fetchInventorySkus () {
	return async (dispatch) => {
		const response = await Inventory.fetchProductTotals()
		dispatch({ type: FETCH_INVENTORY_SKUS_SUCCESS, payload: response.data })
	}
}

export function sortInventorySkus ({
	quantitySortingOrder
} = {}) {
	return async (dispatch) => {
		dispatch({ type: SORT_INVENTORY_SKUS, payload: { quantitySortingOrder } })
	}
}

export function fetchProductMetrics () {
	return async (dispatch) => {
		const response = await Products.getMetrics()
		dispatch({ type: FETCH_PRODUCT_METRICS_SUCCESS, payload: response.data })
	}
}

export function fetchInventoryStockMonitoringData (params) {
	return async (dispatch) => {
		const response = await Inventory.fetchInventoryStockMonitoring(params)
		dispatch({ type: FETCH_INVENTORY_STOCK_MONITORING_SUCCESS, payload: response.data })
	}
}

/**
 * @param {Object} params
 * @param {Object} [options]
 * @param {() => boolean} [options.isLatest] Called once the response arrives. When it returns false a newer request
 * has been made since, so this response is dropped instead of overwriting the newer one.
 */
export function fetchInventoryOrderMovement (params, { isLatest } = {}) {
	return async (dispatch) => {
		const response = await Inventory.indexInventoryOrderMovement(params)
		if (isLatest && !isLatest()) {
			return
		}
		dispatch({ type: FETCH_INVENTORY_ORDER_MOVEMENT_SUCCESS, payload: response.data })
	}
}

export function fetchInventoryScanAdherence (params) {
	return async (dispatch) => {
		const response = await Inventory.indexInventoryScanAdherence(params)
		dispatch({ type: FETCH_INVENTORY_SCAN_ADHERENCE_SUCCESS, payload: response.data })
	}
}

export function fetchWarehouseDetails (id) {
	return async (dispatch) => {
		const response = await Inventory.singleWarehouse(id)
		dispatch({ type: FETCH_WAREHOUSE_DETAILS_SUCCESS, payload: { data: response.data, id } })
	}
}

export function updateInventoryProductItem (payload) {
	return (dispatch) => {
		dispatch({ type: UPDATE_INVENTORY_PRODUCT_ITEM_SUCCESS, payload })
	}
}

export function addInventoryProductItem (payload) {
	return (dispatch) => {
		dispatch({ type: ADD_INVENTORY_PRODUCT_ITEM_SUCCESS, payload })
	}
}

export function fetchInventoryProductItemHistory (cid) {
	return async (dispatch) => {
		const inventoryProductHistoryItems = await InventoryProductItems.fetchInventoryProductItemHistoryOnce(cid)
		dispatch({ type: FETCH_INVENTORY_FEED_ITEMS_SUCCESS, payload: inventoryProductHistoryItems })
	}
}

export function fetchMoreInventoryProductItemHistory (cid, lastDocumentId) {
	return async (dispatch) => {
		const inventoryProductHistoryItems = await InventoryProductItems.fetchMoreInventoryProductItemHistory(cid, lastDocumentId)
		dispatch({ type: FETCH_MORE_INVENTORY_FEED_ITEMS_SUCCESS, payload: inventoryProductHistoryItems })
	}
}

export function addInventoryProductItemHistory (payload) {
	return async (dispatch) => {
		dispatch({ type: ADD_INVENTORY_FEED_ITEM, payload })
	}
}

export function fetchBlockedInventoryProducts ({
	page = 0,
	...searchTerms
} = {}) {
	return async (dispatch) => {
		const response = await Inventory.indexInventoryProducts({
			page,
			blocked: true,
			...searchTerms
		})
		dispatch({ type: FETCH_BLOCKED_INVENTORY_SUCCESS, payload: { data: response.data } })
	}
}

export function blockInventoryProducts ({
	blocked,
	serialNumbers = [],
	remark
} = {}) {
	return async (dispatch) => {
		const response = await Inventory.blockInventoryProducts({
			blocked,
			serialNumbers,
			remark
		})
		dispatch({ type: BLOCK_INVENTORY_ITEMS_SUCCESS, payload: { data: response.data } })
	}
}
